<template>
  <div class="switch-wrapper">
    <h2 class="title">选择房源</h2>

    <div class="search-area">
      <a-form layout="inline">
        <a-form-item label="房源名称">
          <a-input-search
            placeholder="房源名称"
            v-model="queryParam.housingResName"
            style="width: 400px"
            @search="onSearch"
          />
        </a-form-item>

        <a-form-item label="房源编号">
          <a-input-search
            placeholder="房源编号"
            v-model="queryParam.housingResId"
            style="width: 250px"
            @search="onSearch"
          />
        </a-form-item>

        <a-form-item label="权利人名称">
          <a-input-search
            placeholder="权利人名称"
            v-model="queryParam.obligeeName"
            style="width: 250px"
            @search="onSearch"
          />
        </a-form-item>

        <a-button type="primary" style="margin-top: 2px" @click="reset"
            >重置</a-button
          >

        <br />
        <div style="margin-top: 6px">
          <a-form-item label="详细地址">
            <a-input-search
              placeholder="详细地址"
              v-model="queryParam.housingResAddress"
              style="width: 400px"
              @search="onSearch"
            />
          </a-form-item>

          
        </div>
      </a-form>
    </div>

    <a-table
      :pagination="table.pagination"
      :loading="table.loading"
      :columns="table.columns"
      :data-source="table.data"
      :row-key="(record) => record.webId"
      :row-selection="{
        type: 'radio',
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :scroll="{ x: 1200 }"
      @change="handleTableChange"
    >
      <span slot="index" slot-scope="text, record, index">
          {{
            (table.pagination.pageNo - 1) * table.pagination.pageSize +
            index +
            1
          }}
        </span>

        <template slot="housingCover" slot-scope="text, record">
          <div class="cover-cell">
            <img
              v-if="record.housingCover"
              :src="record.housingCover"
              alt="房源封面"
              class="cover-img"
            />
            <span v-else class="cover-empty">暂无封面</span>
          </div>
        </template>

        <template slot="leaseUseType" slot-scope="text, record">
          <span>{{ formatLeaseUseType(record.leaseUseType) }}</span>
        </template>
    </a-table>

    <!-- 按钮 -->
    <div class="btn-row">
      <a-button class="btn-cancel" @click="closeMoudle">取消</a-button>
      <a-button type="primary" @click="selectData">确定</a-button>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "封面",
    dataIndex: "housingCover",
    width: 100,
    scopedSlots: { customRender: "housingCover" },
  },
  { title: "房源名称", dataIndex: "housingResName", width: 250 },
  { title: "房源编号", dataIndex: "webId", width: 150 },
  {
    title: "租赁用途",
    dataIndex: "leaseUseType",
    width: 120,
    scopedSlots: { customRender: "leaseUseType" },
  },
  { title: "详细地址", dataIndex: "housingResAddress", width: 250 },
  {
    title: "最后编辑时间",
    dataIndex: "finalEditTime",
    width: 160,
    key: "finalEditTime",
  },
];
const leaseUseTypeDictionaries = [
  {
    value: "1",
    note: "商业",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "2",
    note: "楼宇办公",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "8",
    note: "园区",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "16",
    note: "仓储",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "32",
    note: "厂房",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "64",
    note: "酒店",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "256",
    note: "住宅",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "512",
    note: "公寓",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "1024",
    note: "工业",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "2048",
    note: "农用",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "4096",
    note: "市政配套",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "8192",
    note: "场地",
    classify: "ZLPT_ZLYT",
  },
  {
    value: "16384",
    note: "其他",
    classify: "ZLPT_ZLYT",
  },
];
import { listResource } from "@/api/property/Property.js";
export default {
  data() {
    return {
      //输入框
      queryParam: {
        housingResName: undefined,
        housingResId: undefined,
        obligeeName: undefined,
        housingResAddress: undefined,
      },
      table: {
        data: [],
        loading: false,
        pagination: {
          showTotal: (total) => `共 ${total} 条`,
        },
        columns,
      },
      selectedRows: [],
      selectedRowKeys: [],
    };
  },
  mounted() {
    this.getTableDetails({
      pageSize: 5,
      page: 1,
      housingResId: this.queryParam.housingResId,
      housingResName: this.queryParam.housingResName,
      housingResAddress: this.queryParam.housingResAddress,
      obligeeName: this.queryParam.obligeeName,
    });
  },

  methods: {
    /**
     * 分页,查询
     * 根据条件筛选并重置分页,可复制
     */
    onSearch() {
      const pager = { ...this.table.pagination };
      pager.current = 1;
      this.handleTableChange(pager);
    },

    /**
     * 分页,点击下一页
     * 表格变化回调，用于分页,筛选和排序,可复制 参数略有修改
     */
    handleTableChange(pagination) {
      //设置重置按钮分页回到第一页
      const pager = { ...this.table.pagination };
      pager.current = pagination.current;
      this.table.pagination = pager;
      this.getTableDetails({
        pageSize: pagination.pageSize,
        page: pagination.current,
        housingResId: this.queryParam.housingResId,
        housingResName: this.queryParam.housingResName,
        housingResAddress: this.queryParam.housingResAddress,
        obligeeName: this.queryParam.obligeeName,
      });
    },

    /**
     * 分页,默认第一页+查询
     * 获取选择层级下角色列表
     */
    getTableDetails(params = {}) {
      this.table.loading = true;
      listResource({
        page: 1,
        pageSize: 5,
        ...params,
      }).then((res) => {
        const pagination = { ...this.table.pagination };
        pagination.total = res.total;
        pagination.pageSize = res.pageSize;
        pagination.pageNo = res.pageNo;
        pagination.current = res.pageNo;
        if (res.pageNo != 1 && res.data.length == 0) {
          //用于新增或删除后自动刷新，避免页面为空现象
          this.getTableDetails({
            pageSize: res.pageSize,
            page: res.pageNo - 1,
            housingResId: this.queryParam.housingResId,
            housingResName: this.queryParam.housingResName,
            housingResAddress: this.queryParam.housingResAddress,
            obligeeName: this.queryParam.obligeeName,
          });
        }
        if (res.pageNo == 1 || res.data.length != 0) {
          this.table.data = res.data;
          this.table.loading = false;
          this.table.pagination = pagination;
        }
      });
    },

    //重置表格查询
    reset() {
      //重置
      this.queryParam.housingResName = undefined;
      this.queryParam.housingResId = undefined;
      this.queryParam.housingResAddress = undefined;
      this.queryParam.obligeeName = undefined;
      this.onSearch();
    },

    /**
     * 刷新当前页(用于新增或删除后自动刷新)
     */
    refreshCurrentPage() {
      const pager = { ...this.table.pagination };
      if (pager.current == undefined || pager.current == 1) {
        this.onSearch();
      } else {
        this.handleTableChange(pager);
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
    },

    closeMoudle() {
      this.$emit("closeMoudle");
    },

    selectData() {
      if (!this.selectedRowKeys?.length) {
        this.$notification.warning({
          message: "请选择房源",
          description: `新建项目失败`,
        });
      } else {
        this.$emit("listSelectHouse", {
          //选择的权证webId列表
          selectHouseList: this.selectedRowKeys,
        });
      }
    },

    //租赁用途转换
    formatLeaseUseType(value) {
      if (!value) return "-";

      let valueList = [];

      if (Array.isArray(value)) {
        valueList = value;
      } else if (typeof value === "string") {
        try {
          valueList = JSON.parse(value);
        } catch (e) {
          valueList = [value];
        }
      }

      if (!Array.isArray(valueList) || valueList.length === 0) {
        return "-";
      }

      const dictMap = leaseUseTypeDictionaries;

      return valueList
        .map((item) => {
          const match = dictMap.find(
            (dict) => String(dict.value) === String(item)
          );
          return match ? match.note : item;
        })
        .join(";");
    },
  },
};
</script>

<style scoped>
.switch-wrapper {
  padding: 10px 20px 0 20px;
}

.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* 按钮行 */
.btn-row {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-cancel {
  border: 1px solid #d9d9d9;
}

/* 输入框高度统一 */
.password-item /deep/ .ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}

.cover-cell {
  width: 70px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
  background: #f5f5f5;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-empty {
  font-size: 12px;
  color: #999;
}
</style>
